export default {
  'pages.rental.table.title': 'Rental Transaction History',
  'pages.rental.table.columns.propRentalId': 'Rental Record ID',
  'pages.rental.table.columns.parkingStructureName': 'Property name',
  'pages.rental.table.columns.recordType': 'Record Type',
  'pages.rental.table.columns.amount': 'Amount',
  'pages.rental.table.columns.paymentDate': 'Payment Date',
  'pages.rental.table.columns.paidUntilMonth': 'Billing Period',
  'pages.rental.table.columns.remarks': 'Remarks',
  'pages.rental.table.columns.operations': 'Actions',

  'pages.rental.recordType.income': 'Income',
  'pages.rental.recordType.expense': 'Expense',

  'pages.rental.actions.add': 'Rental Income & Expense Registration',
  'pages.rental.modal.createTitle': 'Create Rental Income & Expense Registration',
  'pages.rental.modal.editTitle': 'Edit Rental Income & Expense Registration',
  'pages.rental.actions.view': 'View',
  'pages.rental.actions.edit': 'Edit',
  'pages.rental.actions.delete': 'Delete',
  'pages.rental.actions.batchDelete': 'Batch Delete',

  'pages.rental.form.createTitle': 'New Transaction Record',
  'pages.rental.form.editTitle': 'Edit Transaction Record',
  'pages.rental.form.propRentalId': 'Rental Record ID',
  'pages.rental.form.propRentalIdRequired': 'Please enter rental record ID',
  'pages.rental.form.propRentalIdPlaceholder': 'Please enter rental record ID',
  'pages.rental.form.recordType': 'Record Type',
  'pages.rental.form.recordTypeRequired': 'Please select record type',
  'pages.rental.form.recordTypePlaceholder': 'Please select record type',
  'pages.rental.form.amount': 'Amount',
  'pages.rental.form.amountRequired': 'Please enter amount',
  'pages.rental.form.amountPlaceholder': 'Please enter amount',
  'pages.rental.form.paymentDate': 'Payment Date',
  'pages.rental.form.paymentDateRequired': 'Please select payment date',
  'pages.rental.form.paymentDatePlaceholder': 'Please select payment date',
  'pages.rental.form.paidUntilMonth': 'Billing Period',
  'pages.rental.form.paidUntilMonthPlaceholder': 'e.g., 2025-06',
  'pages.rental.form.remarks': 'Remarks',

  'pages.rental.detail.title': 'Transaction Record Details',
  'pages.rental.detail.propRentalId': 'Rental Record ID',
  'pages.rental.detail.recordType': 'Record Type',
  'pages.rental.detail.amount': 'Amount',
  'pages.rental.detail.paymentDate': 'Payment Date',
  'pages.rental.detail.paidUntilMonth': 'Billing Period',
  'pages.rental.detail.remarks': 'Remarks',
  'pages.rental.detail.createdTime': 'Created Time',

  'pages.rental.confirm.deleteTitle': 'Confirm Delete',
  'pages.rental.confirm.deleteContent':
    'Are you sure to delete this transaction record?',
  'pages.rental.confirm.batchDeleteTitle': 'Confirm Batch Delete',
  'pages.rental.confirm.batchDeleteContent':
    'Are you sure to delete {count} selected records?',

  'pages.rental.message.createSuccess': 'Created successfully',
  'pages.rental.message.createFailed': 'Failed to create',
  'pages.rental.message.updateSuccess': 'Updated successfully',
  'pages.rental.message.updateFailed': 'Failed to update',
  'pages.rental.message.deleteSuccess': 'Deleted successfully',
  'pages.rental.message.deleteFailed': 'Failed to delete',
  'pages.rental.message.batchDeleteSuccess': 'Batch deleted successfully',
  'pages.rental.message.batchDeleteFailed': 'Failed to batch delete',
  'pages.rental.message.loadFailed': 'Failed to load record',
  'pages.rental.message.selectRecords': 'Please select records to delete',
};
